module.exports = __webpack_public_path__ + "img/3-find.25594fb3.svg";